import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import 'moment/locale/ru';
import {Card, Form, FormGroup, Label, Input, Modal, ModalBody, ModalHeader,} from "reactstrap";
import {Route, Switch} from 'react-router-dom';
import get from 'lodash/get';
import {useTranslation} from "react-i18next";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import {
    receiveMessage,
    setWsConnected,
    receiveChatUpdate,
    addingNewContactToggleModal,
    addingNewContactRequestStart,
    addingNewContactTouchForm,
    importNewContactsToggleModal,
    importNewContactsRequestStart,
    importNewContactsTouchForm
} from "../../actions/Chats";
import Chats from "./Chats/index";
import Messages from "./Messages/index";
import ChatDetail from "./Detail/ChatDetail";
import ButtonWithSpinner from "../../Components/ButtonWithSpinner";
import DragDropFile from "../../Components/DragDropFile";

import {connect as connectNats, JSONCodec, StringCodec} from "nats.ws";


import {
    IonPage,
    IonContent,
    IonFab,
    IonFabButton,
} from '@ionic/react';

const chatsIconFab = <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M3 0C1.34315 0 0 1.34315 0 3V13.9241C0 15.5809 1.34315 16.9241 3 16.9241H17.1477C18.8046 16.9241 20.1477 15.5809 20.1477 13.9241V6.67233L24 0H17.1477H12.453H3Z"
          fill="white"/>
    <line x1="4.97363" y1="6.25" x2="15.5623" y2="6.25" stroke="#0CA970" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="4.75" y1="10.25" x2="13.25" y2="10.25" stroke="#0CA970" strokeWidth="1.5" strokeLinecap="round"/>
</svg>;

const ChatsWrapper = (
    {
        match,


        addingNewContactTouchForm,
        addingNewContactStateModal,
        addingNewContactToggleModal,
        addingNewContactRequestStart,
        addingNewContactErrors,
        addingNewContactLoading,

        importNewContactsTouchForm,
        importNewContactsStateModal,
        importNewContactsToggleModal,
        importNewContactsRequestStart,
        importNewContactsErrors,
        importNewContactsLoading,
    }
) => {
    const {t, i18n} = useTranslation();

    // State


    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentWillUnmount


    const isMobile = true;

    const [addingNewContactPhone, setAddingNewContactPhone] = useState('');
    const [addingNewContactName, setAddingNewContactName] = useState('');
    const [showModal, setShowModal] = useState(true);

    useEffect(() => {
        if (!addingNewContactStateModal) {
            setAddingNewContactPhone('');
            setAddingNewContactName('');
            addingNewContactTouchForm();
        }
    }, [addingNewContactStateModal]);

    const sendAddingNewContactRequest = (e) => {
        e.preventDefault();
        addingNewContactRequestStart(addingNewContactName, addingNewContactPhone.replace(/[^+\d]/g, ''));
    }

    const [importNewContactsFile, setImportNewContactsFile] = useState('');

    useEffect(() => {
        if (!importNewContactsStateModal) {
            setImportNewContactsFile('');
            importNewContactsTouchForm();
        }
    }, [importNewContactsStateModal]);

    const sendImportNewContactsRequest = (e) => {
        e.preventDefault();
        importNewContactsRequestStart(importNewContactsFile.file);
    }

    return <>
        <AppSidebar/>
        <IonPage id="main-content">
            <AppHeader/>
            <IonContent forceOverscroll={false}>
                <Chats/>
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton routerLink={'/newMessage'} className="i-fab">
                        {chatsIconFab}
                    </IonFabButton>
                </IonFab>

            </IonContent>
        </IonPage>
    </>
};


const mapStateToProps = state => ({
    addingNewContactStateModal: state.Chats.addingNewContactStateModal,
    addingNewContactErrors: state.Chats.addingNewContactErrors,
    addingNewContactLoading: state.Chats.addingNewContactLoading,
    importNewContactsStateModal: state.Chats.importNewContactsStateModal,
    importNewContactsErrors: state.Chats.importNewContactsErrors,
    importNewContactsLoading: state.Chats.importNewContactsLoading,
});

const mapDispatchToProps = dispatch => ({
    receiveMessage: (message) => dispatch(receiveMessage(message)),
    receiveChatUpdate: (chat) => dispatch(receiveChatUpdate(chat)),
    addingNewContactTouchForm: () => dispatch(addingNewContactTouchForm()),
    addingNewContactToggleModal: (bool) => dispatch(addingNewContactToggleModal(bool)),
    addingNewContactRequestStart: (name, phone) => dispatch(addingNewContactRequestStart(name, phone)),
    importNewContactsTouchForm: () => dispatch(importNewContactsTouchForm()),
    importNewContactsToggleModal: (bool) => dispatch(importNewContactsToggleModal(bool)),
    importNewContactsRequestStart: (file) => dispatch(importNewContactsRequestStart(file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatsWrapper);
